import { Participation, Session } from '@app/api';
import { IconChip, IconChipsProps } from '../IconChip';
import { Colors } from '@app/theme';
import { useTranslation } from 'react-i18next';

type Props = {
  color?: Colors;
  session?: Session;
  participation?: Participation;
};

export const DurationChip = ({
  color,
  participation,
  session: sessionProps,
  ...rest
}: Props & IconChipsProps) => {
  const { t } = useTranslation('common');
  const session = participation?.session || sessionProps;
  const duration =
    participation?.durationDisplayed ||
    participation?.duration ||
    session?.durationDisplayed ||
    session?.duration;

  if (!duration) {
    return null;
  }

  return (
    <IconChip
      icon="ri-time-line"
      color={color || 'green'}
      label={t('sessionChips.duration', { value: duration })}
      {...rest}
    />
  );
};
